export default "__VITE_ASSET__BtGe7ZHw__"